export const getUserInitials = (name: string) => {
  const wordsInName = name.split(" ");

  const firstLetter = wordsInName[0][0] ?? "";
  const lastLetter = wordsInName[wordsInName.length - 1][0] ?? "";

  return `${firstLetter}${lastLetter}`;
};
